import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { EditorPage } from './rotas/e/EditorPage';
import { CapturaPage } from './rotas/c/CapturaPage';

// Roteamento mínimo por pathname — o SPA tem só duas rotas (ver CLAUDE.md):
//   /e  editor desktop
//   /c  PWA de captura no celular
// Duas rotas não justificam a dependência de um router. `/` cai no editor.
function App(): JSX.Element {
  const path = window.location.pathname;
  if (path.startsWith('/c')) return <CapturaPage />;
  return <EditorPage />;
}

const el = document.getElementById('root');
if (!el) throw new Error('#root ausente no index.html');
createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
